import children from "./images/teens.svg";
import christian from "./images/bible.svg";
import gender from "./images/gender.svg";
import rights from "./images/adoption.svg";

const list = [
    {
        id: 1,
        title: "CHRISTIANITY ",
        para: "We concede to one God the Father, Son and Holy Spirit through Christ Jesus the love, mercy and grace of God made known to us and we maintain our Christian identity while being sensitive to the diverse perspectives accordingly as we convey this identity.",
        image: christian
    },
    {
        id: 2,
        title: "CHILDREN AND YOUTHS WELFARE",
        para: "To look after orphans and vulnerable children and the youths in their distress through the provision of basic levels of nurturance and care. We believe an informed and transformed children society will without doubt change their environments.",
        image: children
    },
    {
        id: 3,
        title: "GENDER AND DIVERSITY",
        para: "To take care of orphaned children and the youths regardless of their gender.",
        image: gender
    },
    {
        id: 4,
        title: "CHILDREN’S RIGHTS",
        para: "In coalition with children and human rights advocates to uphold lawful rights respectively. To work holistically with individual children and youths to address their social, spiritual and physical need.",
        image: rights
    }
];

export default list;